import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Floral = ({ variant = "top", mirrored = false, className = "" }) => (
  <img
    src={`/images/floral-${variant}.png`}
    alt=""
    aria-hidden
    draggable={false}
    className={`pointer-events-none select-none ${mirrored ? "-scale-x-100 " : ""}${className}`}
  />
);

export const GoldDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden>
    <span className="h-px w-14 bg-gold/60 sm:w-20" />
    <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
    <span className="h-px w-14 bg-gold/60 sm:w-20" />
  </div>
);

export const SectionHeading = ({ eyebrow, title, script = false, className = "" }) => (
  <div className={`text-center ${className}`}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2
      className={`mt-3 ${script ? "font-script text-5xl sm:text-6xl" : "font-serif text-4xl uppercase tracking-[0.12em] sm:text-5xl"} text-ink`}
    >
      {title}
    </h2>
  </div>
);

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-gold-border bg-paperdeep py-5" data-testid="marquee">
    <div className="flex w-max animate-marquee items-center gap-10">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center gap-10" aria-hidden={dup === 1}>
          {items.map((t, i) => (
            <span key={i} className="flex items-center gap-10 font-serif text-xl italic text-sage-dark">
              <span className="whitespace-nowrap">{t}</span>
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
